import { Injectable, Inject } from 'ng-metadata/core';
import {HttpService} from '../../../../infra/httpRequest/http.service';

@Injectable()
export class ProgressBarService {

    private primaBaseUrl:any;
    private ilsServices:object={};
    
	constructor (private httpService: HttpService,
				 @Inject('$translate') private $translate,
				 @Inject('restBaseURLs') private restBaseURLs,
				 @Inject('$q') private $q: ng.IQService) {
					this.primaBaseUrl = restBaseURLs.requestStatusMapURL;
					this.ilsServices = {
						    '/requestStatusMap': {
                                'path': restBaseURLs.requestStatusMapURL,        
                                'method': 'GET'
                            } ,
                            '/datesMap': {
                                'path': restBaseURLs.datesMapURL,        
                                'method': 'GET'
                            }

                    }; 
	}

	private resquestInProgress:Object = {};
	    
    public getRequestStatusMap(){
		let params = {};   
        return this.makeIlsRequest('/requestStatusMap', params);
    }

    public getDatesMap(instCode, requestid, expirationDate){
        let params = {instCode: instCode, requestid: requestid, expirationDate: expirationDate};   
        return this.makeIlsRequest('/datesMap', params);
    }

    public getServices(){
        return this.ilsServices;
	}
	
	makeIlsRequest(serviceName: string, params: Object){
        if(!params){
            params= {};
        }
        let ngrsService = this.ilsServices[serviceName];
        this.resquestInProgress[serviceName] = true;

        return this.httpService.call(ngrsService.method, ngrsService.path, params)
            .then(
                (response)=> {
                    return this.ilsRequestSuccess(response);
                },
                (error)=>{
                    return this.ilsRequestFailure(error, serviceName, params);
                }
            ).finally( () =>
                this.resquestInProgress[serviceName] = false
            );
    }
    
	get requestInProgress(){
        return this.resquestInProgress || false;
    }

    private ilsRequestSuccess(response){
        return response;
    }

    private ilsRequestFailure(reason, serviceName, params) {
        console.error(reason, serviceName);
        return reason;
    }
}




// WEBPACK FOOTER //
// ./src/main/webapp/components/search/fullView/ngrs/progressBar/progressBar.service.ts